import { useEffect, useRef, useState } from 'react';

import Map from 'ol/Map';
import View from 'ol/View';
import TileLayer from 'ol/layer/Tile';
import XYZ from 'ol/source/XYZ';
import { fromLonLat } from 'ol/proj';
import MouseWheelZoom from 'ol/interaction/MouseWheelZoom';
import PinchZoom from 'ol/interaction/PinchZoom';
import DragPan from 'ol/interaction/DragPan';
import { defaults as defaultControls, Zoom, Attribution, FullScreen } from 'ol/control';
import { defaults as defaultInteractions } from 'ol/interaction';
import { platformModifierKeyOnly } from 'ol/events/condition';
import styles from "../mapLocationPicker.scss"
import { getWindowWidth, isMobileScreen } from '../../../../services/utils';

const zoom = new Zoom({
  className: styles.olZoom
})

const attribution = new Attribution({
  collapsed: true,
  className: styles.olAttribution
})

const fullScreen = new FullScreen({
  className: styles.olFullscreen
})


export const useInitializeMap = (mapElementName, value) => {
  const [mapInstance, setMapInstance] = useState(null);
  const isMobile = isMobileScreen(getWindowWidth());

  useEffect(() => {
    const map = new Map({
      target: mapElementName,
      layers: [
        new TileLayer({
          source: new XYZ({
            url: 'https://tile.openstreetmap.org/{z}/{x}/{y}.png',
            attributions: '© <a target="_blank" href="https://www.openstreetmap.org/copyright">OpenStreetMap</a> contributors'
          })
        }),
        // markerLayer, // todo: add marker layer
      ],
      view: new View({
        center: fromLonLat([value.longitude, value.latitude]),
        zoom: 15,
      }),

      controls: defaultControls({ attribution: false, zoom: false, rotate: false }).extend([
        zoom,
        attribution,
        !isMobile && fullScreen,
      ].filter(Boolean)),
      interactions: defaultInteractions({
        mouseWheelZoom: false,
        dragPan: !isMobile, // Disable dragPan on mobile
        pinchRotate: false // Disable rotation
      })
    });

    // Add MouseWheelZoom that only works when Ctrl is pressed (unless in fullscreen)
    const mouseWheelZoom = new MouseWheelZoom({
      condition: (event) => {
        // In fullscreen, always allow mouse wheel zoom
        if (document.fullscreenElement) {
          return true;
        }
        // Outside fullscreen, require Ctrl key
        return platformModifierKeyOnly(event);
      }
    });
    map.addInteraction(mouseWheelZoom);

    // Add PinchZoom for two-finger zoom on touch devices
    const pinchZoom = new PinchZoom();
    map.addInteraction(pinchZoom);

    // On mobile, add custom DragPan that requires two fingers
    if (isMobile) {
      const dragPan = new DragPan({
        condition: function (event) {
          return this.getPointerCount() === 2 || platformModifierKeyOnly(event);
        }
      });
      map.addInteraction(dragPan);
    }



    setMapInstance(map);

    return () => {
      map.setTarget(null);
    };


  }, [])

  return mapInstance
}



// WEBPACK FOOTER //
// ./src/containers/AdFormPage/LocationSelector/hooks/useInitializeMap.tsx